import React from "react";
import { ReactComponent as ImagePlaceHolder } from "../../../../../public/preview_image_placeholder.svg";
import ImagePicker from "../../../../shared/ImagePicker";

export default ({
  previewImage,
  onChange,
  checkCoverSizeValidation = false,
}) => (
  <div className="img-uploader">
    <ImagePicker
      onSubmit={onChange}
      checkCoverSizeValidation={checkCoverSizeValidation}
    >
      {previewImage ? (
        <img
          style={{ objectFit: "cover" }}
          width={315}
          height={315}
          src={previewImage.url}
          alt={previewImage.id}
        />
      ) : (
        <ImagePlaceHolder width={315} height={315} />
      )}
    </ImagePicker>
  </div>
);
